<template lang="pug">
div
    div.box
        v-server-table(
            :url="datatableUrl",
            :name="tableName",
            ref="datatable",
            :columns="columns",
            :options="options"
        )
            template(slot="beforeTable")
                datatable-loader(:name="tableName")

    div.box
        attendance-summary
</template>

<script>
import attendanceSummary from './staff-attendance-summary.vue';
import dateFormat from '../../../mixins/date-format';
import { mapState } from 'vuex';

export default {
    components: { attendanceSummary },
    mixins: [dateFormat],

    data() {
        return {
            tableName: 'ATTENDANCE_REPORT',
            columns: ['name', 'time_in', 'time_out', 'duration'],
            options: {
                perPage: 2000,
                perPageValues: [2000],
                useReportFilter: true,
                customFilters: ['outlet_id', 'since', 'until', 'filters'],
                texts: {
                    title: 'Staff Attendance Report',
                    description: 'Staff attendance history',
                },
                skin: 'table m-b-0 b-b',
                templates: {
                    time_in: (h, row) => {
                        if (_.isNull(row.time_in)) {
                            return '';
                        }

                        return this.dateFormat(row.time_in);
                    },

                    time_out: (h, row) => {
                        if (_.isNull(row.time_out)) {
                            return '';
                        }
                        return this.dateFormat(row.time_out);
                    },
                },
                responseAdapter(res) {
                    const data = res.data.data;
                    const grouped = _.groupBy(data, 'time_in_date');
                    const results = [];

                    _.forEach(grouped, (rows, dates) => {
                        results.push({
                            name: moment(dates, 'YYYY-MM-DDTHH:mm:ss[Z]')
                                .format('dddd, DD MMM YYYY')
                                .toUpperCase(),
                            time_in: null,
                            time_out: null,
                            duration: '',
                            parent: true,
                        });

                        rows.forEach(row => {
                            row.parent = false;
                            results.push(row);
                        });
                    });

                    return {
                        data: results,
                        count: res.data.count,
                    };
                },

                rowClassCallback(row) {
                    if (row.parent) {
                        return 'table-row-divider';
                    }

                    return null;
                },

                orderBy: {
                    column: 'time_in',
                    ascending: false,
                },

                pdf_url: Laroute.route(
                    'franchise.report.staff_attendance.export_attendance',
                    { type: 'PDF' },
                ),
                csv_url: Laroute.route(
                    'franchise.report.staff_attendance.export_attendance',
                    { type: 'CSV' },
                ),
                xls_url: Laroute.route(
                    'franchise.report.staff_attendance.export_attendance',
                    { type: 'XLSX' },
                ),
            },
        };
    },

    computed: {
        ...mapState('tillFilter', ['filters']),

        datatableUrl() {
            return Laroute.route(
                'franchise.report.staff_attendance.attendance_list',
                {
                    typeDate: this.$store.getters.typeDate,
                },
            );
        },
    },

    watch: {
        filters: function(to, from) {
            if (to === from) return;

            this.setFilter();
        },
    },

    created() {
        this.removeLimitState();
        window.addEventListener('beforeunload', this.removeLimitState);
    },

    methods: {
        setFilter() {
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'filters',
                value: this.filters,
            });
        },

        removeLimitState() {
            let query = JSON.parse(
                localStorage.getItem(`vuetables_${this.tableName}`),
            );

            if (!_.isNull(query) && !_.isUndefined(query.perPage)) {
                query.perPage = 2000;

                localStorage.setItem(
                    `vuetables_${this.tableName}`,
                    JSON.stringify(query),
                );
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/report/staff-attendance/staff-attendance-list.vue